// SEO text content for listing pages, parametrized with {loc} (e.g. "Ungheni"
// or "Botanica, Chișinău"). Structure per page: H1 -> intro (50-80 words) ->
// listings -> long text (h2 + paragraphs) -> internal links -> CTA.

const CONTENT = {
  apartamente: {
    1: {
      intro:
        'Cauți un apartament de vânzare în {loc}? Pe LVG Imob găsești oferte actuale de apartamente cu 1, 2, 3 sau mai multe camere, în diferite zone ale orașului și pentru bugete diferite. Poți compara proprietățile disponibile după suprafață, număr de camere, stare, amplasare și preț, apoi poți solicita rapid informații suplimentare sau o vizionare.',
      h2: 'Găsește apartamentul potrivit în {loc}',
      paragraphs: [
        'Alegerea unui apartament nu înseamnă doar compararea prețului pe metru pătrat. Contează zona, compartimentarea, etajul, starea blocului, reparația, infrastructura din apropiere și costurile care pot apărea după cumpărare.',
        'LVG Imob te ajută să analizezi ofertele disponibile și să identifici proprietățile care corespund cerințelor tale. Dacă ai găsit un apartament care te interesează, poți solicita detalii despre proprietate și programa o vizionare.',
        'În catalog poți găsi atât apartamente care necesită renovare, cât și locuințe gata pentru mutare. Ofertele se actualizează pe măsură ce apar proprietăți noi sau se modifică disponibilitatea celor existente.',
        'Dacă intenționezi să cumperi prin credit ipotecar, este util să stabilești din timp bugetul disponibil, avansul și condițiile de finanțare. Astfel poți căuta direct proprietăți care se încadrează într-un buget realist.',
      ],
    },
    2: {
      intro:
        'Descoperă apartamente de închiriat în {loc} disponibile pentru termen lung sau în condițiile indicate de proprietar. Pe LVG Imob poți verifica ofertele actuale, prețurile, numărul de camere, zona și caracteristicile fiecărei locuințe înainte de a solicita o vizionare.',
      h2: 'Chirie în {loc} în funcție de buget și necesități',
      paragraphs: [
        'Atunci când cauți un apartament în chirie, prețul lunar este doar unul dintre criterii. Zona, mobilierul, electrocasnicele disponibile, condițiile contractuale, termenul chiriei și cheltuielile suplimentare pot influența semnificativ alegerea finală.',
        'În această pagină sunt afișate apartamente disponibile pentru chirie în {loc}. Poți analiza fotografiile și informațiile fiecărei proprietăți și poți contacta LVG Imob pentru detalii suplimentare.',
        'Pentru a găsi mai repede o ofertă potrivită, stabilește câteva criterii de bază: bugetul lunar, numărul de camere, zona preferată, data aproximativă a mutării și perioada pentru care dorești să închiriezi.',
        'Ofertele de chirie se pot modifica rapid, iar unele proprietăți pot deveni indisponibile într-un timp scurt. De aceea, dacă găsești un apartament care corespunde cerințelor tale, recomandăm să verifici disponibilitatea și să programezi o vizionare.',
      ],
    },
  },
  case: {
    1: {
      intro:
        'Vezi case de vânzare în {loc} și împrejurimi și compară proprietățile disponibile după suprafața locuinței, teren, amplasare, stare și preț. LVG Imob publică proprietăți pentru diferite necesități — de la case care pot fi renovate după propriul proiect până la locuințe pregătite pentru trai.',
      h2: 'Cum alegi o casă în {loc}',
      paragraphs: [
        'Cumpărarea unei case presupune mai multe verificări decât alegerea unui apartament. Pe lângă suprafața locuinței și numărul de camere, merită analizate terenul aferent, accesul, utilitățile, starea construcției și costurile eventualelor lucrări.',
        'Localizarea este la fel de importantă. Pentru unele familii contează apropierea de centrul orașului, școli și magazine, iar pentru altele prioritatea este un teren mai mare, liniștea sau accesul rapid spre principalele drumuri.',
        'Pe LVG Imob poți vedea casele disponibile în {loc} și informațiile principale despre fiecare proprietate. Dacă o ofertă corespunde cerințelor tale, poți solicita detalii suplimentare și programa o vizionare.',
        'Înainte de cumpărare este recomandat să analizezi nu doar prețul solicitat, ci și investițiile care ar putea fi necesare după tranzacție. O casă cu un preț inițial mai mic poate presupune cheltuieli importante pentru reparații, încălzire, acoperiș, instalații sau amenajarea terenului.',
      ],
    },
    2: {
      intro:
        'Cauți o casă de închiriat în {loc}? Consultă ofertele disponibile și verifică suprafața locuinței, numărul de camere, curtea, dotările, zona și condițiile de chirie. LVG Imob te ajută să găsești mai ușor proprietățile care se potrivesc necesităților și bugetului tău.',
      h2: 'Chiria unei case în {loc}',
      paragraphs: [
        'O casă în chirie poate fi o alegere potrivită pentru familii, persoane care au nevoie de mai mult spațiu sau pentru cei care preferă o curte proprie în locul unui apartament.',
        'Înainte de a lua o decizie, verifică atent ce este inclus în chirie și ce cheltuieli rămân în responsabilitatea chiriașului. Contează sistemul de încălzire, costurile utilităților, mobilierul, electrocasnicele, locurile de parcare și modul în care poate fi utilizată curtea.',
        'De asemenea, este important să clarifici perioada minimă de închiriere, garanția solicitată și condițiile stabilite de proprietar.',
        'Pe LVG Imob sunt publicate case disponibile pentru chirie în {loc} atunci când există astfel de proprietăți în ofertă. Pentru fiecare anunț poți consulta informațiile disponibile și poți solicita detalii sau o vizionare.',
      ],
    },
  },
  terenuri: {
    1: {
      intro:
        'Descoperă terenuri de vânzare în {loc} și împrejurimi pentru construcție, investiție sau alte destinații indicate în anunț. Compară ofertele după suprafață, amplasare, acces, utilități și preț și solicită informații suplimentare înainte de a programa o vizionare.',
      h2: 'Ce trebuie verificat înainte de cumpărarea unui teren',
      paragraphs: [
        'Prețul și numărul de ari nu sunt suficiente pentru a determina dacă un teren este potrivit pentru proiectul tău. Unul dintre cele mai importante elemente este destinația terenului și ce poate fi construit sau realizat legal pe proprietatea respectivă.',
        'Trebuie luate în calcul și accesul până la teren, forma parcelei, frontul stradal, relieful și disponibilitatea utilităților. Racordarea la electricitate, apă, canalizare sau gaz poate influența considerabil bugetul total al unei construcții.',
        'Localizarea poate avea un impact important și asupra valorii viitoare a terenului. O proprietate situată într-o zonă aflată în dezvoltare poate avea perspective diferite față de una amplasată într-o zonă deja construită.',
        'Pe LVG Imob poți consulta terenurile disponibile în {loc} și informațiile oferite pentru fiecare proprietate. Dacă un teren te interesează, solicită detalii suplimentare despre amplasare și caracteristicile acestuia înainte de a lua o decizie.',
      ],
    },
    2: {
      intro:
        'Vezi terenurile disponibile pentru chirie în {loc} și află informații despre suprafață, amplasare, acces și condițiile de utilizare. În funcție de proprietate și destinația permisă, un teren poate fi potrivit pentru activități comerciale, depozitare sau alte utilizări stabilite împreună cu proprietarul.',
      h2: 'Închirierea unui teren în {loc}',
      paragraphs: [
        'Înainte de închirierea unui teren este important să stabilești exact pentru ce urmează să fie utilizată proprietatea. Cerințele pentru un teren destinat depozitării, unei activități comerciale sau unei utilizări temporare pot fi foarte diferite.',
        'Verifică accesul auto, suprafața utilă, disponibilitatea electricității sau a altor utilități și condițiile prevăzute de proprietar. Pentru activități comerciale trebuie analizat și dacă utilizarea dorită este compatibilă cu terenul respectiv.',
        'Pe LVG Imob sunt afișate terenurile disponibile pentru chirie atunci când există astfel de oferte în {loc}.',
      ],
    },
  },
  'spatii-comerciale': {
    1: {
      intro:
        'Cauți un spațiu comercial de cumpărat în {loc}? Descoperă proprietăți disponibile pentru afaceri sau investiții și compară ofertele după suprafață, amplasare, acces, configurație și preț.',
      h2: 'Spații pentru afaceri și investiții în {loc}',
      paragraphs: [
        'Un spațiu comercial trebuie analizat în primul rând în funcție de activitatea care urmează să fie desfășurată acolo. Vizibilitatea și traficul pietonal pot fi esențiale pentru un magazin, în timp ce pentru un birou pot conta mai mult accesibilitatea, parcarea și compartimentarea.',
        'Pentru alte tipuri de activități pot deveni importante accesul pentru transport, intrarea separată, puterea electrică disponibilă sau posibilitatea de modificare a spațiului.',
        'Dacă proprietatea este cumpărată ca investiție, trebuie analizat și potențialul de închiriere. Amplasarea, starea spațiului și cererea din zona respectivă pot influența atât nivelul chiriei, cât și timpul necesar pentru găsirea unui chiriaș.',
        'LVG Imob publică spații comerciale disponibile în {loc} pentru diferite tipuri de activități și bugete. Pentru fiecare proprietate poți verifica informațiile disponibile și poți solicita detalii suplimentare sau o vizionare.',
      ],
    },
    2: {
      intro:
        'Găsește spații comerciale de închiriat în {loc} pentru magazin, birou, servicii sau alte activități. Compară ofertele disponibile după suprafață, zonă, vizibilitate, acces și preț și solicită o vizionare pentru proprietățile care corespund afacerii tale.',
      h2: 'Alege spațiul potrivit pentru afacerea ta',
      paragraphs: [
        'Pentru un spațiu comercial, locația poate avea un impact direct asupra activității. Un magazin sau showroom poate avea nevoie de vizibilitate și trafic pietonal, în timp ce un birou poate pune accent pe acces, confort și posibilitatea de parcare.',
        'Înainte de semnarea unui contract de chirie este important să verifici suprafața efectiv utilizabilă, compartimentarea, accesul, utilitățile și eventualele costuri suplimentare.',
        'Trebuie analizat și dacă spațiul poate fi adaptat activității tale. Unele afaceri au nevoie de amenajări speciale, acces separat, spații pentru depozitare sau o anumită capacitate a rețelei electrice.',
        'Pe LVG Imob poți consulta spațiile comerciale disponibile pentru chirie în {loc} și poți solicita informații suplimentare despre proprietățile care te interesează.',
      ],
    },
  },
  garajuri: {
    1: {
      intro:
        'Descoperă garaje de vânzare în {loc} și compară ofertele disponibile după suprafață, amplasare, acces și preț. Pe LVG Imob poți verifica informațiile fiecărei proprietăți și poți solicita detalii suplimentare.',
      h2: 'Cum alegi un garaj în {loc}',
      paragraphs: [
        'Înainte de cumpărare, verifică suprafața, accesul auto, starea construcției și amplasarea garajului. Contează și apropierea față de locuință sau locul de muncă.',
        'Pe LVG Imob poți consulta garajele disponibile în {loc} și poți solicita informații suplimentare despre proprietățile care te interesează.',
      ],
    },
    2: {
      intro:
        'Vezi garajele disponibile pentru chirie în {loc} și află informații despre suprafață, acces și condițiile de utilizare. Poți contacta LVG Imob pentru detalii suplimentare.',
      h2: 'Închirierea unui garaj în {loc}',
      paragraphs: [
        'Înainte de închiriere, verifică suprafața, accesul auto, securitatea și condițiile stabilite de proprietar.',
        'Pe LVG Imob sunt afișate garajele disponibile pentru chirie atunci când există astfel de oferte în {loc}.',
      ],
    },
  },
  altele: {
    1: {
      intro:
        'Vezi proprietățile de vânzare în {loc} din categoria Altele și compară ofertele disponibile după caracteristici, amplasare și preț. Poți solicita informații suplimentare despre fiecare proprietate.',
      h2: 'Proprietăți diverse de vânzare în {loc}',
      paragraphs: [
        'În categoria Altele găsești proprietăți cu destinații diferite. Verifică descrierea fiecărui anunț pentru a înțelege ce include proprietatea și cum poate fi utilizată.',
        'Pe LVG Imob poți consulta proprietățile disponibile în {loc} și poți contacta echipa pentru detalii suplimentare.',
      ],
    },
    2: {
      intro:
        'Vezi proprietățile de închiriat în {loc} din categoria Altele și află condițiile de utilizare pentru fiecare ofertă. Poți contacta LVG Imob pentru detalii.',
      h2: 'Proprietăți diverse de închiriat în {loc}',
      paragraphs: [
        'Verifică descrierea fiecărui anunț pentru a înțelege destinația proprietății și condițiile de chirie stabilite de proprietar.',
        'Pe LVG Imob sunt afișate proprietățile disponibile pentru chirie atunci când există astfel de oferte în {loc}.',
      ],
    },
  },
};

// Internal links shown under the long text.
// same: the current category (linked with the opposite sale type);
// others: two related categories (linked with the current sale type).
const LINK_SETS = {
  apartamente: {
    same: { base: 'apartamente', label: 'Apartamente' },
    others: [{ base: 'case', label: 'Case' }, { base: 'terenuri', label: 'Terenuri' }],
  },
  case: {
    same: { base: 'case', label: 'Case' },
    others: [{ base: 'apartamente', label: 'Apartamente' }, { base: 'terenuri', label: 'Terenuri' }],
  },
  terenuri: {
    same: { base: 'terenuri', label: 'Terenuri' },
    others: [{ base: 'case', label: 'Case' }, { base: 'apartamente', label: 'Apartamente' }],
  },
  'spatii-comerciale': {
    same: { base: 'spatii-comerciale', label: 'Spații comerciale' },
    others: [{ base: 'apartamente', label: 'Apartamente' }, { base: 'case', label: 'Case' }],
  },
  garajuri: {
    same: { base: 'garajuri', label: 'Garaje' },
    others: [{ base: 'apartamente', label: 'Apartamente' }, { base: 'case', label: 'Case' }],
  },
  altele: {
    same: { base: 'altele', label: 'Proprietăți' },
    others: [{ base: 'apartamente', label: 'Apartamente' }, { base: 'case', label: 'Case' }],
  },
};

export function getSeoContent(base, saleType, loc) {
  const forBase = CONTENT[base];
  if (!forBase || !loc) return null;
  const c = forBase[Number(saleType) === 2 ? 2 : 1];
  if (!c) return null;
  const fill = (text) => text.replaceAll('{loc}', loc);
  return {
    intro: fill(c.intro),
    h2: fill(c.h2),
    paragraphs: c.paragraphs.map(fill),
  };
}

// First entry is the same category with the opposite sale type; the rest are
// related categories with the current sale type.
export function getInternalLinks(base, saleType, loc) {
  const set = LINK_SETS[base];
  if (!set) return [];
  const other = Number(saleType) === 2 ? 1 : 2;
  // On a vânzare page, related links say "de vânzare"; on chirie — "de închiriat".
  const action = Number(saleType) === 2 ? 'închiriat' : 'vânzare';
  const otherAction = Number(saleType) === 2 ? 'vânzare' : 'închiriat';
  return [
    { label: `${set.same.label} de ${otherAction} în ${loc}`, base: set.same.base, saleType: other },
    ...set.others.map((o) => ({
      label: `${o.label} de ${action} în ${loc}`,
      base: o.base,
      saleType: Number(saleType),
    })),
  ];
}

// Rooms-specific content for the apartments landing pages
// (/apartamente/ungheni/1-camera etc.) — deliberately different from the
// generic apartments text, written around each format's real use case.
export const ROOMS_CONTENT = {
  1: {
    intro:
      'Cauți o garsonieră sau un apartament cu 1 cameră de vânzare în {loc}? Aici găsești oferte compacte, potrivite pentru o persoană sau un cuplu, cu prețuri și suprafețe variate.',
    h2: 'Garsonieră sau apartament cu 1 cameră în {loc}',
    paragraphs: [
      'Un apartament cu 1 cameră este alegerea obișnuită pentru prima locuință sau pentru o investiție ușor de închiriat. Costurile de întreținere sunt mai mici, iar cererea pentru chirii rămâne constant ridicată.',
      'La vizionare verifică suprafața utilă, poziția blocului, etajul și starea instalațiilor. Chiar și un spațiu compact poate fi compartimentat inteligent, cu sufragerie deschisă și spații de depozitare bine gândite.',
      'Pe LVG Imob găsești apartamentele cu 1 cameră disponibile în {loc}, cu fotografii și informații actualizate pentru fiecare anunț.',
    ],
  },
  2: {
    intro:
      'Apartamentele cu 2 camere de vânzare în {loc} sunt printre cele mai căutate. Compară ofertele disponibile după suprafață, etaj, stare și preț și programează o vizionare.',
    h2: 'Cum alegi un apartament cu 2 camere în {loc}',
    paragraphs: [
      'Formatul de 2 camere acoperă cel mai larg segment de cumpărători: cupluri tinere, persoane care lucrează de acasă sau familii cu un copil. Flexibilitatea compartimentării contează la fel de mult ca suprafața totală.',
      'La compararea ofertelor ia în calcul lumina naturală, prezența balconului sau a logiei, starea blocului și costurile lunare de întreținere. Un apartament bine întreținut poate economisi mii de euro la mutare.',
      'Vezi apartamentele cu 2 camere disponibile în {loc} pe LVG Imob și solicită detalii suplimentare pentru proprietățile care corespund bugetului tău.',
    ],
  },
  3: {
    intro:
      'Un apartament cu 3 camere în {loc} oferă spațiu pentru familie, compartimentare flexibilă și mai mult confort. Vezi ofertele active, prețurile și proprietățile disponibile.',
    h2: 'Apartament cu 3 camere în {loc} — spațiu pentru familie',
    paragraphs: [
      'Pentru familii, un apartament cu 3 camere înseamnă dormitoare separate pentru părinți și copii, plus un living comun. La alegere contează apropierea de școli, grădinițe, parcuri și accesul la transport.',
      'Verifică dacă apartamentul are două grupuri sanitare, spațiu de depozitare și posibilitatea de reconfigurare. Compară blocurile noi cu cele secundare — diferențele de preț pot fi compensate de costuri de reparație mai mici.',
      'Dacă intenționezi să cumperi prin credit ipotecar, stabilește din timp bugetul și avansul. Pe LVG Imob poți consulta apartamentele cu 3 camere disponibile în {loc} și poți solicita o vizionare.',
    ],
  },
  4: {
    intro:
      'Apartamentele cu 4 sau mai multe camere de vânzare în {loc} oferă spațiu generos pentru familii numeroase. Vezi ofertele disponibile, prețurile și fotografiile.',
    h2: 'Apartamente cu 4+ camere în {loc}',
    paragraphs: [
      'Pentru mai mult de trei camere, oferta este mai restrânsă, iar proprietățile bune se dau rapid. Contactează LVG Imob pentru a fi anunțat când apare o ofertă potrivită.',
    ],
  },
};

export function getRoomsContent(rooms, loc) {
  const content = ROOMS_CONTENT[rooms] || ROOMS_CONTENT[4];
  if (!content || !loc) return null;
  const fill = (text) => text.replaceAll('{loc}', loc);
  return {
    intro: fill(content.intro),
    h2: fill(content.h2),
    paragraphs: content.paragraphs.map(fill),
  };
}
